<tui-editor
  #editor
  class="message-input"
  [class.message-input_invalid]="invalid"
  [floatingToolbar]="floatingToolbar"
  [tools]="toolbarTools"
  [placeholder]="placeholder"
  [formControl]="control"
  (keydown)="keydown($event, editor)"
></tui-editor>
